/**
 * US-English dollars → words for large-money readback (≥ $1,000 confirm gate).
 * Example: 23086 → "twenty-three thousand eighty-six dollars"
 */

const ONES = [
  '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
  'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
  'seventeen', 'eighteen', 'nineteen',
]
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']

function underThousand(n: number): string {
  if (n < 20) return ONES[n] || ''
  if (n < 100) {
    const t = Math.floor(n / 10)
    const o = n % 10
    return o ? `${TENS[t]}-${ONES[o]}` : TENS[t]
  }
  const h = Math.floor(n / 100)
  const rest = n % 100
  return rest ? `${ONES[h]} hundred ${underThousand(rest)}` : `${ONES[h]} hundred`
}

function integerWords(n: number): string {
  if (n === 0) return 'zero'
  const parts: string[] = []
  const billions = Math.floor(n / 1_000_000_000)
  const millions = Math.floor((n % 1_000_000_000) / 1_000_000)
  const thousands = Math.floor((n % 1_000_000) / 1000)
  const rem = n % 1000
  if (billions) parts.push(`${underThousand(billions)} billion`)
  if (millions) parts.push(`${underThousand(millions)} million`)
  if (thousands) parts.push(`${underThousand(thousands)} thousand`)
  if (rem) parts.push(underThousand(rem))
  return parts.join(' ')
}

/** Whole-dollar words; cents appended when non-zero. */
export function dollarsToWords(dollars: number): string {
  if (!Number.isFinite(dollars) || dollars < 0) return ''
  const centsTotal = Math.round(dollars * 100)
  const whole = Math.floor(centsTotal / 100)
  const cents = centsTotal % 100
  const dollarNoun = whole === 1 ? 'dollar' : 'dollars'
  let out = `${integerWords(whole)} ${dollarNoun}`
  if (cents > 0) {
    const centNoun = cents === 1 ? 'cent' : 'cents'
    out += ` and ${integerWords(cents)} ${centNoun}`
  }
  return out
}

/** True when readback confirm gate applies (absolute dollars ≥ 1000). */
export function needsMoneyWordsConfirm(dollars: number): boolean {
  return Number.isFinite(dollars) && Math.abs(dollars) >= 1000
}
